import { useState } from "react";
import { useTranslation } from "react-i18next";
import headerImage from "../img/freefit_cibus_header.png";
import phone1Group1 from "../img/freefit_cibus_phone_1_group_1.png";
import phone1Group2 from "../img/freefit_cibus_phone_1_group_2.png";
import phone2Group1 from "../img/freefit_cibus_phone_2_group_1.png";
import phone2Group2 from "../img/freefit_cibus_phone_2_group_2.png";
import phone3Group1 from "../img/freefit_cibus_phone_3_group_1.png";
import phone3Group2 from "../img/freefit_cibus_phone_3_group_2.png";
import freefitLogo2 from "../img/freefit_logo_2.png";
import arrow_down from "../img/svg/arrow_down.svg";
import arrow_left_red from "../img/svg/arrow_left_red.svg";
import bowling from "../img/svg/bowling.svg";
import location from "../img/svg/location.svg";
import mailRedIcon from "../img/svg/mail_red_icon.svg";
import phoneRedIcon from "../img/svg/phone_red_icon.svg";
import sport from "../img/svg/sport.svg";
import whatsappIcon from "../img/svg/whatsapp_icon.svg";

function FreefitCibus() {
  const { t } = useTranslation();
  const faqs = [
    {
      question: t("FREEFIT_CIBUS.FAQ.QUESTIONS.HOW_VOUCHER_WORKS"),
      answer: t("FREEFIT_CIBUS.FAQ.ANSWERS.HOW_VOUCHER_WORKS"),
    },
    {
      question: t("FREEFIT_CIBUS.FAQ.QUESTIONS.SAME_PRICE"),
      answer: t("FREEFIT_CIBUS.FAQ.ANSWERS.SAME_PRICE"),
    },
    {
      question: t("FREEFIT_CIBUS.FAQ.QUESTIONS.CHECK_PRICES"),
      answer: t("FREEFIT_CIBUS.FAQ.ANSWERS.CHECK_PRICES"),
    },
    {
      question: t("FREEFIT_CIBUS.FAQ.QUESTIONS.VOUCHER_USED"),
      answer: t("FREEFIT_CIBUS.FAQ.ANSWERS.VOUCHER_USED"),
    },
    {
      question: t("FREEFIT_CIBUS.FAQ.QUESTIONS.VOUCHER_EXPIRY"),
      answer: t("FREEFIT_CIBUS.FAQ.ANSWERS.VOUCHER_EXPIRY"),
    },
    {
      question: t("FREEFIT_CIBUS.FAQ.QUESTIONS.MORE_QUESTIONS"),
      answer: t("FREEFIT_CIBUS.FAQ.ANSWERS.MORE_QUESTIONS"),
    },
    {
      question: t("FREEFIT_CIBUS.FAQ.QUESTIONS.GET_CODE"),
      answer: t("FREEFIT_CIBUS.FAQ.ANSWERS.GET_CODE"),
    },
    {
      question: t("FREEFIT_CIBUS.FAQ.QUESTIONS.USE_VOUCHER"),
      answer: t("FREEFIT_CIBUS.FAQ.ANSWERS.USE_VOUCHER"),
    },
  ];

  const Accordion = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <div className="accordion-item">
        <button onClick={() => setIsOpen(!isOpen)} className="accordion-header">
          {isOpen ? (
            <img className={"accordion-arrow"} src={arrow_left_red} />
          ) : (
            <img className={"accordion-arrow"} src={arrow_down} />
          )}
          <div
            className={`accordion-question ${isOpen ? "question-open" : ""}`}
          >
            {question}
          </div>
        </button>
        {isOpen && (
          <p
            className="accordion-body"
            dangerouslySetInnerHTML={{ __html: answer }}
          ></p>
        )}
      </div>
    );
  };

  return (
    <div className="freefit-cibus-wrapper">
      <header>
        <img className="header-image" src={headerImage} />
        <img className="freefit-logo-2" src={freefitLogo2} />
      </header>
      <main>
        <div className={"stats-container"}>
          <div className={"stats-item"}>
            <img src={location} />
            <div className={"amount"}>2000</div>
            <div className={"text"}>{t("FREEFIT_CIBUS.STATS.CLUBS")}</div>
          </div>
          <div className={"stats-item"}>
            <img src={sport} />
            <div className={"amount"}>25</div>
            <div className={"text"}>{t("FREEFIT_CIBUS.STATS.SPORTS")}</div>
          </div>
          <div className={"stats-item"}>
            <img src={bowling} />
            <div className={"amount"}>150</div>
            <div className={"text"}>{t("FREEFIT_CIBUS.STATS.ATTRACTIONS")}</div>
          </div>
        </div>
        <div className={"phones-container"}>
          <div className={"title-container"}>
            <div className={"title"}>{t("FREEFIT_CIBUS.HAVE_VOUCHER")}</div>
            <div className={"sub_title"}>{t("FREEFIT_CIBUS.WHAT_NEXT")}</div>
          </div>

          <div className={"phone-row"}>
            <div className={"phone-item"}>
              <img alt={"phone"} src={phone1Group1} />
              <div className={"number-and-text-container"}>
                <div className={"number-container"}>
                  <div className={"number"}>1</div>
                </div>
                <div className={"text"}>{t("FREEFIT_CIBUS.STEPS.STEP_1")}</div>
              </div>
            </div>
            <div className={"phone-item"}>
              <img alt={"phone"} src={phone2Group1} />
              <div className={"number-and-text-container"}>
                <div className={"number-container"}>
                  <div className={"number"}>2</div>
                </div>
                <div className={"text"}>{t("FREEFIT_CIBUS.STEPS.STEP_2")}</div>
              </div>
            </div>
            <div className={"phone-item"}>
              <img alt={"phone"} src={phone3Group1} />
              <div className={"number-and-text-container"}>
                <div className={"number-container"}>
                  <div className={"number"}>3</div>
                </div>
                <div className={"text"}>{t("FREEFIT_CIBUS.STEPS.STEP_3")}</div>
              </div>
            </div>
          </div>

          <div className={"title-container"}>
            <div className={"sub_title"}>{t("FREEFIT_CIBUS.HOW_IT_WORKS")}</div>
          </div>

          <div className={"phone-row"}>
            <div className={"phone-item"}>
              <img alt={"phone"} src={phone1Group2} />
              <div className={"number-and-text-container"}>
                <div className={"number-container"}>
                  <div className={"number"}>1</div>
                </div>
                <div className={"text"}>{t("FREEFIT_CIBUS.STEPS.STEP_4")}</div>
              </div>
            </div>
            <div className={"phone-item"}>
              <img alt={"phone"} src={phone2Group2} />
              <div className={"number-and-text-container"}>
                <div className={"number-container"}>
                  <div className={"number"}>2</div>
                </div>
                <div className={"text"}>{t("FREEFIT_CIBUS.STEPS.STEP_5")}</div>
              </div>
            </div>
            <div className={"phone-item"}>
              <img alt={"phone"} src={phone3Group2} />
              <div className={"number-and-text-container"}>
                <div className={"number-container"}>
                  <div className={"number"}>3</div>
                </div>
                <div className={"text"}>{t("FREEFIT_CIBUS.STEPS.STEP_3")}</div>
              </div>
            </div>
          </div>
        </div>
        <div className={"qa-container"}>
          <div className={"title"}>{t("FREEFIT_CIBUS.FAQ.TITLE")}</div>
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <Accordion key={index} {...faq} />
            ))}
          </div>
        </div>
        <div className={"connect-container"}>
          <div className={"title"}>{t("FREEFIT_CIBUS.CONTACT.TITLE")}</div>
          <div className={"items-container"}>
            <div className={"item"}>
              <img src={mailRedIcon} />
              <div>
                <div className={"type"}>{t("FREEFIT_CIBUS.CONTACT.EMAIL")}</div>
                <a
                  href="mailto:office@freefit.co.il"
                  target={"_blank"}
                  className={"address"}
                >
                  office@freefit.co.il
                </a>
              </div>
            </div>
            <div className={"item"}>
              <img alt={"phone"} src={phoneRedIcon} />
              <div>
                <div className={"type"}>{t("FREEFIT_CIBUS.CONTACT.PHONE")}</div>
                <a
                  href="tel:0559458809"
                  target={"_blank"}
                  className={"address"}
                >
                  03-3730300
                </a>
              </div>
            </div>
            <div className={"item"}>
              <img src={whatsappIcon} />
              <div>
                <div className={"type"}>
                  {t("FREEFIT_CIBUS.CONTACT.WHATSAPP")}
                </div>
                <a
                  href="https://wa.me/972559458809"
                  target={"_blank"}
                  className={"address"}
                >
                  055-9458809
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footer>
        <div className={"container"}>
          <div className={"links-container"}>
            <a href={"https://freefit.co.il/Pages/ClubList/"} target={"_blank"}>
              {t("FREEFIT_CIBUS.FOOTER.CLUB_LIST")}
            </a>
            <a href={"https://freefit.co.il/Pages/Policy/"} target={"_blank"}>
              {t("FREEFIT_CIBUS.FOOTER.TERMS")}
            </a>
            <a
              href={"https://freefit.co.il/Documents/PrivacyPolicy.pdf"}
              target={"_blank"}
            >
              {t("FREEFIT_CIBUS.FOOTER.PRIVACY")}
            </a>
            <a
              href={
                "https://freefit.co.il/Documents/AccessibilityStatement.pdf"
              }
              target={"_blank"}
            >
              {t("FREEFIT_CIBUS.FOOTER.ACCESSIBILITY")}
            </a>
          </div>
          <div className={"freefit-rights"}>
            {t("FREEFIT_CIBUS.FOOTER.COPYRIGHT")}
          </div>
        </div>
      </footer>
    </div>
  );
}

export default FreefitCibus;
